<template>
    <vx-card :title="pageTitle" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-1/4 mb-1">
                <div class="mt-1">
                    <vs-input
                        v-model="form.id"
                        autocomplete="off"
                        label="ID объявления"
                        placeholder="Введите id..."
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/4 mb-1">
                <div class="mt-2">
                    <vs-button class="mt-5" color="success" @click="get(true)" type="filled"> Получить </vs-button>
                </div>
            </div>
        </div>

        <vs-table :data="items" max-items="10" class="mt-5">
            <template slot="header">
            </template>
            <template slot="thead">
                <vs-th> Ad id</vs-th>
                <vs-th> View ad</vs-th>
                <vs-th> View expected user</vs-th>
                <vs-th> CPM ad</vs-th>
                <vs-th> CPM value user</vs-th>
                <!--<vs-th> CPM users</vs-th>-->
                <vs-th> CPM coeffs </vs-th>
                <vs-th> Date </vs-th>
                <!-- <vs-th> CPM coeff = 1.2 </vs-th>
                <vs-th> CPM value user = 1.2 </vs-th>
                <vs-th> CPM coeff = 1.8 </vs-th>
                <vs-th> CPM value user = 1.8 </vs-th>
                <vs-th> Delta coeff = 1.2 </vs-th>
                <vs-th> Delta coeff = 1.8</vs-th> --> 
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>{{ tr.adId }}</vs-td>
                    <vs-td>{{ tr.viewsAd }}</vs-td>
                    <vs-td>{{ tr.viewExpectedUser }}</vs-td>
                    <vs-td>{{ tr.cpmAd | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.cpmValueUser | formatNumber(3) }}</vs-td>
                    <!-- <vs-td>             
                        <div style="overflow-y: scroll; max-height: 250px;">
                            <json-viewer v-if="tr.cpmUsers" :value="tr.cpmUsers"></json-viewer>
                        </div>
                    </vs-td> -->
                    <vs-td>             
                        <div style="overflow-y: scroll; max-height: 250px;">
                            <json-viewer v-if="tr.items" :value="tr.items"></json-viewer>
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.createdAt | moment('DD.MM.YYYY HH:mm') }}</vs-td>
                    <!-- <vs-td>{{ tr.items.length > 0 ? tr.items[0].cpm : 0 | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.items.length > 0 ? tr.items[0].users : 0 | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.items.length > 1 ? tr.items[1].cpm : 0 | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.items.length > 1 ? tr.items[1].users : 0 | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.items.length > 0 ? tr.items[0].delta : 0 | formatNumber(3) }}</vs-td>
                    <vs-td>{{ tr.items.length > 1 ? tr.items[1].delta : 0 | formatNumber(3) }}</vs-td> -->
                </vs-tr>
            </template>           
        </vs-table>

        <vs-pagination :max="5" :total="pagesTotal" v-model="page" class="mt-3"></vs-pagination>
    </vx-card>
</template>


<script>
import qs from 'qs';
import axios from 'axios';
import JsonViewer from 'vue-json-viewer';

export default {
    name: 'forecast-cpm',
    data() {
        return {
            pageTitle: 'Прогноз CPM',
            items: [],
            form: {
                id: '',
            },

            page: 1,
            pageSize: 25,
            pagesTotal: 1
        };
    },
    mounted() {
        this.get(true);
    },
    methods: {
        get(reset) {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            if (reset) {
                this.page = 1;
            }

            var params = {
                adId: this.form.id,
                page: this.page,
                size: this.pageSize
            }

            this.axios
                .all([
                    this.axios.get('recommendation-cpm', {
                        params: params
                    }),
                    this.axios.get('recommendation-cpm/count', {
                        params: params
                    })
                ])
                .then(
                    axios.spread((items, count) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.items = items.data;
                        this.pagesTotal = Math.ceil(count.data / this.pageSize);
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки логов.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        }
    },
    components: {
        JsonViewer
    },
    watch: {
        page: function () {
            this.get();
        },
        // "form.id": function () {
        //     this.page = 1;
        // },
    }
};
</script>

<style>
.date-p {
    display: block;
}
.b-btn {
  border-radius: 0;
  width: 200px;
}
.vs-pagination--mb {
    justify-content: center !important;
}
td.cut-text { 
    max-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
</style>